import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  pageGroupName: string;
}

const SubHeader = styled.div`
  font-weight: 700;
  padding: 12px 8px 4px;
`;

export const ExperienceTablePageGroupSubHeader = ({ pageGroupName }: IProps) => (
  <SubHeader>{pageGroupName || '[未分類]'}</SubHeader>
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/ExperienceTablePageGroupSubHeader.tsx